<template>
  <div>
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">Berita</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <v-card class="mx-3 mt-3">
      <v-data-table
        :headers="dessertHeaders"
        :items="res_master_news.data"
        :single-expand="true"
        :expanded.sync="expanded"
        item-key="id"
        hide-default-footer
        show-expand
        class="elevation-1 pa-2"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>List Berita</v-toolbar-title>
            <v-spacer />
            <v-btn color="primary" @click="goToAdd" dark class="mb-2">
              Tambah
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.title="{ item }">
          <p class="pa-0 ma-0">{{ item.title }}</p>
          <p class="text-grey-sm pa-0 ma-0">{{ item.slug }}</p>
        </template>
        <template v-slot:item.banner_image_url="{ item }">
          <v-avatar class="ma-2" size="50" tile>
            <img :src="item.banner_image_url" alt="John" />
          </v-avatar>
        </template>
        <template v-slot:item.deletedAt="{ item }">
          <span class="text-blue" v-if="item.deletedAt === null">Aktif</span>
          <span class="text-red-md" v-else>Tidak Aktif</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            class="ma-1"
            @click="showEdit(item.id)"
            fab
            dark
            x-small
            color="#235c92"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            class="ma-1"
            @click="showModalDelete(item.id)"
            fab
            dark
            x-small
            color="red"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <span v-html="item.content_preview"> </span>
            <v-btn color="primary lighten-2" @click="goToDetail(item)" text>
              Lihat Detail
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-pagination
        class=""
        :total-visible="7"
        v-model="pages"
        :length="res_master_news.meta.total_page"
      ></v-pagination>
    </v-card>
    <!-- ------------------------- modal -------------------------- -->

    <!-- modal Delete -->
    <v-dialog v-model="deleteDialog" persistent max-width="450">
      <v-card class="pa-2">
        <v-card-title class="text-blood pl-2 pt-1 pr-0 pb-3"
          >Delete Berita
          <v-spacer></v-spacer>
          <v-icon
            class="float-right"
            color="grey"
            @click.prevent="deleteDialog = false"
            >mdi-close></v-icon
          >
        </v-card-title>
        <div class="text-center pa-3">
          <v-avatar size="142px" class="mb-4">
            <img src="@/assets/img/delete.png" />
          </v-avatar>
          <p class="text-blood">Apakah anda ingin menghapus Berita ini?</p>
        </div>
        <v-card-actions class="py-0 px-10">
          <v-spacer></v-spacer>
          <v-btn
            width="100%"
            rounded
            color="#f58522"
            @click="deleteDialog = false"
            block
            dark
          >
            <span class="text-capitalize text-blue"
              ><span class="text-white"> Close</span></span
            >
          </v-btn>
        </v-card-actions>
        <v-card-actions class="py-0 px-10 mt-3 justify-center text-center">
          <v-btn
            :loading="loadingDel"
            @click="submitDelete"
            text
            block
            color="#f58522"
            >Yas! Delete role</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >{{ label }} Berita <br />Success</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="#f58522"
            :loading="loading"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >{{ label }} Berita <br />Failed</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="#f58522"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const news = createNamespacedHelpers("news");

export default {
  name: "Home",
  mounted() {
    this.$store.commit("news/SET_PAGESIZE", 10);
    this.$store.commit("news/SET_PAGINATION", 1);
    this.$store.dispatch("news/getMasterNews");
    this.pages = this.page;
    console.log("res_master_news", this.res_master_news);
  },
  computed: {
    ...news.mapState(["res_master_news", "page"])
  },
  data() {
    return {
      menu: false,
      pages: null,
      deleteDialog: false,
      dialog: false,
      dialog2: false,
      label: null,
      loadingDel: false,
      dessertHeaders: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "banner_image_url"
        },
        { text: "Title", value: "title" },
        { text: "Autor", value: "author_name" },
        { text: "Status", value: "deletedAt" },
        { text: "Action", value: "action" }
      ]
    };
  },
  components: {},
  watch: {
    pages(val) {
      this.$store.commit("news/SET_PAGINATION", val);
      this.$store.dispatch("news/getNews");
    }
  },
  methods: {
    goToDetail(val) {
      this.$store.commit("news/SET_IDNEWS", val.id);
      this.$router.push("/" + val.slug);
    },
    showEdit(val) {
      this.$router.push("/master/news/edit/" + val);
    },
    goBack() {
      this.$router.go(-1);
    },
    closeSuccessNavigate() {
      this.$router.go();
    },
    goToAdd() {
      this.$router.push("/master/news/add");
    },
    showModalDelete(val) {
      this.deleteDialog = true;
      this.$store.commit("news/SET_IDNEWS", val);
    },
    submitDelete() {
      // button effect
      this.label = "Delete";
      this.loadingDel = true;
      this.$store
        .dispatch("news/deleteNews")
        .then(response => {
          const res = response.data;
          if (res.data) {
            this.deleteDialog = false;
            this.dialog = true;
            this.loadingDel = false;
          } else {
            this.deleteDialog = false;
            this.dialog2 = true;
            this.loadingDel = false;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          this.errorMessage = message;
          this.deleteDialog = false;
          this.dialog2 = true;
          this.loadingDel = false;
        });
    }
  }
};
</script>
